import {styled} from "@reside/ui";

export const SectionInstruction = styled.p<{$muted?: boolean}>`
  font-size: ${({theme}) => theme.fontSize[3]}px;
  color: ${({theme, $muted}) =>
    $muted ? theme.color.gray100 : theme.color.darkBlue100};
  margin: 0 0 ${({theme}) => theme.space[4]}px 0;
  opacity: ${({$muted}) => ($muted ? 0.7 : 1)};
`;

export const SectionBlock = styled.div`
  margin-bottom: ${({theme}) => theme.space[6]}px;
`;

export const InfoNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({theme}) => theme.space[2]}px;
  font-size: ${({theme}) => theme.fontSize[2]}px;
  color: ${({theme}) => theme.color.gray150};
  margin-bottom: ${({theme}) => theme.space[4]}px;
  font-weight: ${({theme}) => theme.fontWeight.medium};
`;
